import { SVGProps, Ref, forwardRef } from 'react';

export const FlameOutlinedSize32Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={32} height={32} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="m13.135 1.333 1.154.705c3.827 2.339 5.036 5.625 5.253 8.303.079.968.03 1.853-.065 2.586a8 8 0 0 0 2.084-1.398c.479-.439.936-.934 1.284-1.486l.788-1.315 1.087 1.087c3.995 3.997 4.83 9.21 3.078 13.458-1.755 4.258-6.042 7.394-11.924 7.394-7.297 0-13.907-6.038-12.296-14.624.613-3.269 2.387-5.327 4.173-7.202 1.804-1.895 3.59-3.587 4.822-6.278zm.97 3.498c-1.38 2.431-3.15 4.124-4.617 5.665-1.729 1.815-3.075 3.444-3.552 5.99-1.291 6.883 3.905 11.78 9.938 11.78 4.964 0 8.341-2.598 9.706-5.908 1.232-2.988.877-6.682-1.64-9.824-2.066 2.296-4.923 3.156-7.89 3.65.352-.976.76-1.94.953-2.963.59-3.14-.34-6.35-2.898-8.39"
                fill="currentColor"
            />
        </g>
    </svg>
));
FlameOutlinedSize32Glyph.displayName = 'FlameOutlinedSize32Glyph';
